import { useEffect, useState } from "react";
import { Container, Row, Col, Input, Card, CardBody } from "reactstrap";
import { getData } from "../../../CommonElements/Functions/PostGetFun";
import { API } from "../../../api/API";
import { dynamicImage } from "../../../Utils";
import { H4, Image, LI, ProgressBar, UL } from "../../../AbstractElements";
import CommonTableNew from "../../Tables/ReactstrapTables/BasicTables/Common/CommonTableNew";
import FeatherIconCom from "../../../Utils/CommonComponents/CommonIcons/FeatherIconCom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import CardHeaderSpan from "../../../Utils/CommonComponents/CardHeaderSpan";
import { ensureDexieReady, getDataFromDexie } from "../../../db/DexieServises";
import SvgIcon from "../../../Utils/CommonComponents/CommonIcons/CommonSvgIcons";

export default function FtpImportLogs() {
    const [ftpImportLogs, setFtpImportLogs] = useState<any[]>([]);
    const [searchText, setSearchText] = useState('');
    const [displayedData, setDisplayedData] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    const serverUrl = localStorage.getItem('serverUrl');
    const APP_TOKEN = localStorage.getItem('appToken');
    const ftpLogCardData = ftpImportLogs.map((item, index) => ({
        id: item.FtpImportLogId,
        color: 'primary',
        icon: 'improvement', // you can adjust icon based on context
        title: `File: ${item.FilePath.split('/').pop()}`,
        text: item.FilePath,
        comment: [
            { id: 1, icon: 'calendar', spanText: `Created: ${item.CreatedAt?.split(' ')[0] || 'N/A'}` },
            { id: 2, icon: 'arrow-up', spanText: `Total Records: ${item.NoTotalRecords}` },
            { id: 3, icon: 'check-circle', spanText: `Success: ${item.NoSuccessfulRecords}` },
            { id: 4, icon: 'x-circle', spanText: `Failed: ${item.NoFailedRecords}` },
            { id: 5, icon: 'clock', spanText: `Start: ${item.StartTime?.split(' ')[0] || '-'}` },
            { id: 6, icon: 'clock', spanText: `End: ${item.EndTime?.split(' ')[0] || '-'}` },
            { id: 7, icon: 'refresh-ccw', spanText: item.IsFileProcessing ? 'Processing' : 'Completed' }
        ],
        progressValue: item.NoSuccessfulRecords && item.NoTotalRecords
            ? Math.round((item.NoSuccessfulRecords / item.NoTotalRecords) * 100)
            : 0,
    }));

    useEffect(() => {
        fetchLogs();
    }, []);

    const fetchLogs = async () => {
        if (!serverUrl || !APP_TOKEN) {
            console.error('❌ Missing server URL or APP_TOKEN');
            return;
        }
        await ensureDexieReady();
        const orgdata = await getDataFromDexie('OrgUnit');
        const companyId = orgdata?.[0]?.CompanyId;
        // console.log(companyId, '===============OrgUnit-> companyId ');
        setLoading(true);

        try {
            const url = `${serverUrl}${API.getFtpImportLogs}`;
            const { status, data } = await getData(url, true, { company_id: companyId });

            if (status === 200 && Array.isArray(data?.data)) {
                setFtpImportLogs(data.data);
                setDisplayedData(data.data);
            } else {
                setFtpImportLogs([]);
                setDisplayedData([]);
            }
        } catch (error) {
            console.error("❌ Failed to fetch FTP Import Logs:", error);
            setFtpImportLogs([]);
            setDisplayedData([]);
        } finally {
            setLoading(false);
        }
    };

    const keys = ftpImportLogs.length > 0 ? Object.keys(ftpImportLogs[0]) : [];

    const headData = keys.map((key, index) => ({
        id: `${index + 1}`,
        head: key,
        key: key,
        sortKey: key
    }));

    // 🔍 Search Filtering
    useEffect(() => {
        const lower = searchText.toLowerCase();
        const filtered = ftpImportLogs.filter((item) =>
            keys.some(k => String(item[k])?.toLowerCase().includes(lower))
        );
        setDisplayedData(filtered);
    }, [searchText, ftpImportLogs]);

    // ⬇️ Export Logic
    const handleExportToExcel = () => {
        const exportData = displayedData.map((row: Record<string, any>) => {
            const rowData: Record<string, any> = {};
            keys.forEach(key => {
                rowData[key] = row[key];
            });
            return rowData;
        });

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'FTP Import Logs');

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, `FTP_Import_Logs_${new Date().toISOString().split("T")[0]}.xlsx`);
    };

    return (
        <div className="">
            <Container fluid className="project-dashboard pb-2 pt-2">
                {/* <CardHeaderSpan headingClassName='pb-2 pt-0' back={true} heading={'FTP '} span={'ReportListTitle'} /> */}
                <Col xl={12} className="col-xl-100 box-col-12">
                    <Row>
                        {/* <div
                                  className="d-flex overflow-auto flex-nowrap"
                                  style={{ gap: '15px', padding: '10px' }}
                                  > */}
                        {ftpLogCardData.map((item) => (
                            <Col xl={4} lg={4} key={item.id}>
                                <Card className="web-card">
                                    <CardBody>
                                        <div className="d-flex">
                                            <div className="header-top">
                                                <div className={`mobile-app bg-light-${item.color}`}>
                                                    <span></span>
                                                    <SvgIcon iconId={item.icon} />
                                                </div>
                                                <div className="flex-grow-1">
                                                    <H4>{item.title}</H4>
                                                    <span>{item.text}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="comment">
                                            <UL className='simple-list flex-row flex-wrap ' style={{ gap: '10px' }}>
                                                {item.comment.map((list) => (
                                                    <LI key={list.id} style={{ whiteSpace: 'wrap' }}>
                                                        <span>{list.spanText}</span>
                                                    </LI>
                                                ))}
                                            </UL>
                                        </div>
                                        <div className="col-12">
                                            <div className="progress-value">
                                                <div className='d-flex justify-content-between'>
                                                    <span>Progress</span>
                                                    <span>{item.progressValue}%</span>
                                                </div>
                                                <ProgressBar value={item.progressValue} color={item.color} />
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        ))}



                        {/* </div> */}
                    </Row>

                </Col>
            </Container>
            {/* <Container fluid>
                <CardHeaderSpan headingClassName='pb-2 pt-0' back={true} heading={'FTP Import Logs'} span={'ReportListTitle'} />

                <Row className="align-items-center justify-content-between mb-3">
                    <Col md="4">
                        <Input
                            type="text"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            placeholder="🔍 Search logs"
                        />
                    </Col>

                    <Col md="auto">
                        <button className="btn btn-sm btn-primary d-flex align-items-center" onClick={handleExportToExcel}>
                            <FeatherIconCom iconName="Download" size={14} className="text-light" />
                            <span className="px-2" style={{ fontSize: 14 }}>Export</span>
                        </button>
                    </Col>
                </Row>

                {loading ? (
                    <div className="text-center py-3">
                        <Image
                            className="b-r-10 img-80"
                            src={dynamicImage('dashboard/loader.gif')}
                            alt="Loading..."
                        />
                    </div>
                ) : (
                    <CommonTableNew
                        caption=""
                        headData={headData}
                        data={displayedData}
                        renderRow={(row, rowIndex) => (
                            <tr key={rowIndex}>
                                {keys.map((key, colIndex) => (
                                    <td key={colIndex}>{row[key]}</td>
                                ))}
                            </tr>
                        )}
                    />
                )}
            </Container> */}
        </div>
    );
}
